export function getVisibleTrimSelectionColumnCount(viewportWidth: number): number {
  if (viewportWidth < 760) {
    return 1;
  }

  if (viewportWidth < 1280) {
    return 2;
  }

  if (viewportWidth < 1920) {
    return 3;
  }

  return 4;
}
